<section class="flex flex-col min-h-screen">
  <app-attendee-header class="sticky z-10 top-0 left-0"></app-attendee-header>

  <main class="attendee-content container mb-5 pt-5 lg:mb-8">
    <div *ngIf="backLink" class="flex px-0 col-span-12 lg:col-span-1">
      <app-back-link
        [backLink]="backLink"
        [ariaLabel]="backLinkAriaLabel"
        [enableHistoryNavigation]="true"
      ></app-back-link>
    </div>

    <div class="col-span-12" [ngClass]="contentContainerClass">
      <ng-content></ng-content>
    </div>
  </main>

  <app-attendee-footer class="mt-auto"></app-attendee-footer>
</section>
